export default function Button(
  props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
) {
  const { className = '', children, ...rest } = props;

  return (
    <button
      className={`py-3 px-6 rounded-sm transition-colors bg-pmw-bb-hero-light dark:bg-pmw-bb-hero-dark hover:bg-pmw-bb-hero-hover-light dark:hover:bg-pmw-bb-hero-hover-dark text-center font-unibet font-medium text-[20px] leading-[20px] text-monoX ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
